import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@shadcn-in-nx/ui/button";
import { TableCell, TableRow } from "@shadcn-in-nx/ui/table";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@shadcn-in-nx/ui/dropdown-menu";
import { MoreVertical, Trash2 } from "lucide-react";
import Icon from "../../components/Icon";

function DatabaseTableRow({ table, databaseId, onDelete }) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <TableRow className="bg-gray-50/50 hover:bg-gray-100/50">
            <TableCell>
                <div className="flex items-center gap-2 pl-8">
                    <Icon name="Table" className="w-4 h-4 text-gray-500" />
                    <button
                        onClick={() => navigate(`/databases/${databaseId}/tables/${table.id}`, {
                            state: { sidebarOpen: false }
                        })}
                        className="text-blue-600 hover:text-blue-800 hover:underline text-left"
                    >
                        {table.name}
                    </button>
                </div>
            </TableCell>
            <TableCell className="text-muted-foreground text-sm hidden md:table-cell">
                {table.aiDescription || "—"}
            </TableCell>
            <TableCell className="hidden lg:table-cell" />
            <TableCell>
                <div className="flex items-center justify-between">
                    <span className="text-sm text-muted-foreground">
                        {new Date(table.updatedAt).toLocaleDateString()}
                    </span>
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <Button variant="ghost" size="sm" className="h-8 w-8 p-0" onClick={(e) => e.stopPropagation()}>
                                <MoreVertical className="w-4 h-4" />
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end">
                            <DropdownMenuItem
                                onClick={(e) => { e.stopPropagation(); onDelete(); }}
                                className="text-red-600 focus:text-red-600"
                            >
                                <Trash2 className="w-4 h-4 mr-2" />
                                {t("common.delete")}
                            </DropdownMenuItem>
                        </DropdownMenuContent>
                    </DropdownMenu>
                </div>
            </TableCell>
        </TableRow>
    );
}

export default DatabaseTableRow;
